<template>
    <Cmember :curnavkv="curnavkv" :navsub.sync="navsub" :options="c_options" @optionchange="optionchange" @groupupdate="groupup">
        <Clearner v-if="navsub==0 && isload" :options="c_myoption" :grouplist="grouplist"></Clearner>
        <Cgroup v-if="navsub==1 && isload" :navsub="101" :options="c_myoption"></Cgroup>
        <div class="profile" v-if="navsub==2 && isload">
            <dl><dt>{{$common.dicword('title',true)}}</dt><dd>{{$common.langinfo(infoschool.title,infoschool.title_en)}}</dd></dl>
            <dl><dt>{{$common.dicword('fulltitle',true)}}</dt><dd>{{infoschool.titlefull}}</dd></dl>
            <dl><dt>{{$common.dicword('address',true)}}</dt><dd>{{infoschool.address}}</dd></dl>
            <dl><dt>{{$common.dicword('linkman',true)}}</dt><dd>{{infoschool.linkman}}</dd></dl>
            <dl><dt>{{$common.dicword('contact',true)}}</dt><dd>{{infoschool.contact}}</dd></dl>
            <dl><dt>{{$common.dicword('Email',true)}}</dt><dd>{{infoschool.email}}</dd></dl>
            <dl><dt>{{$common.dicword('datebegin',true)}}</dt><dd>{{$common.basic.dateformat(infoschool.datebegin)}}</dd></dl>
            <dl><dt>{{$common.dicword('dateend',true)}}</dt><dd>{{$common.basic.dateformat(infoschool.dateend)}}</dd></dl>
        </div>
    </Cmember>

</template>

<script>
    import { mixinmember } from "@/mixin/mixin"
    export default {
        name: 'learner',
        mixins: [mixinmember],
        data() {
            return {
                curnavkv: 21,
                infoschool: {}
            };
        },
        components: {
            Clearner: () => import('@/components/Clearner'),
            Cgroup: () => import('@/components/Cgroup')
        },
        computed: {

            c_options: function () {
                let _options = { 'hasoption': true, 'haskw': true, 'hasgroup': 1, 'showschool': true, 'showgroup': true };
                switch (this.navsub) {
                    case 1:
                        _options.showgroup = false;
                        break;
                    case 2:
                        _options.showgroup = false;
                        _options.haskw = false;
                        break;
                }
                return _options;
            },
            c_myoption: function () {
                let _myoption = this.$common.basic.jsonclone(this.myoption);
                _myoption.tk = 1;
                return _myoption;
            }
        },
        methods: {
            getdata: function () {
                this.isload = true;
                if (this.navsub == 2) {
                    let jsondata = { 'postdata': { 'act': 'tc_mem_school', 'id': this.myoption.schoolid } };
                    this.$common.post(jsondata, res => {
                        this.infoschool = res.infodata;
                    });
                }
            }
        }
    }
</script>
